module.exports = __webpack_public_path__ + "static/media/Icon2.a27d4692.svg";